import React, { useEffect, useState } from 'react';
import { useForm } from "react-final-form";
import styled from 'styled-components';
import { Modal } from "ui-kit/Modal";
import { Button } from "ui-kit/Button";
import { FormValues } from "components/NewRelease/ReleaseInfo/types";
import { FormInput } from 'ui-kit/SmartForm';
import IntlStore from "stories/IntlStore";
import FormSelect from './FormSelect';
import {FormattedMessage} from "react-intl";
import { aw } from 'react-router/dist/development/register-DCE0tH5m';
import { ProgressSpinner } from "primereact/progressspinner";

interface Label {
  id: number;
  name: string;
}
interface LabelItem {
  id: string | number;
  name: string;
}

interface AddLabelModalProps {
  isOpen: boolean;
  onHide: () => void;
  contributorCreating: boolean;
  name: string;
  label:any;
  labels: any;
  createLabel: (name: string, length: string) => Promise<void>;
  check: any;
  checkingStatus: 'Available' | 'NotAvailable' | 'Checking' | '';
  checking: boolean;
  getLabels:()=>void
  
}

export const AddLabelModal: React.FC<AddLabelModalProps> = props => {
  const { label, labels, createLabel, check, checkingStatus, checking } = props
  const { isOpen, onHide, contributorCreating,  } = props;
  const [selectedlabel, setSelectedlabel] = useState<string>('');
  const { change, getState } = useForm<FormValues>();
  const values = getState().values;
  const [checkLabel, setCheckLabel] = useState('')
  const [create, setCreate] = useState('')
  const isSaveDisabled = checkLabel !== 'isLabel'
  
  const onCreateContributor = async () => {
    try {
      await createLabel(String(values.label), `${labels?.length}`)
      await props.getLabels()
      onHide();
      setSelectedlabel('');
      setCreate('');
    } catch (error) {
      console.error('Ошибка при создании label:', error);
    }
  };

  const onCheck = () => {
    check(label)
 

  }
  useEffect(() => {
    setCheckLabel('')
  }, [label])
useEffect(()=>{
  if (checkingStatus === 'Available') {
    setCheckLabel('isLabel');
    return;
  }

  if (checkingStatus === 'NotAvailable') {
    values.label = null;
    setCheckLabel('wrong');
    return;
  }

  // Для начального состояния и во время запроса не показываем
  // ни зелёный, ни красный статус
  setCheckLabel('');
},[checkingStatus, values])

  return (
    <Modal
      visible={isOpen}
      className="no-mobile-margin"
      onHide={() => {
        onHide();
        setCreate('')
        values.label = null
      }}
      dismissableMask
      showHeader={false}
      header={null}
      footer={(
        create === 'Create' && <Footer>
          <Button loading={contributorCreating} disabled={isSaveDisabled} onClick={onCreateContributor}>
            {checkLabel == 'isLabel' ? (
                <FormattedMessage
                  id="NewRelease.ReleaseInfo.CreateLabel"
                  defaultMessage="Create label"
                />
              ) : (
              <FormattedMessage
                id="NewRelease.ReleaseInfo.UpdateLabel"
                defaultMessage="Update label"
              />
            )}
          </Button>
        </Footer>
      )}
    >
      <FormContainer>
        {create === "Create" ? <Section>
          <Label>
            <FormattedMessage
              id="NewRelease.ReleaseInfo.LabelCreation"
              defaultMessage="Label creation"
            />
          </Label>
          <Box>
            <FormInput
              id="label"
              name="label"
              label={IntlStore.intl.formatMessage({
                id: "NewRelease.ReleaseInfo.ReleaseLabel",
                defaultMessage: "label "
              })}
              placeholder={IntlStore.intl.formatMessage({
                id: "NewRelease.ReleaseInfo.ReleaseLabel.Placeholder",
                defaultMessage: "Enter label name"
              })}
              tooltip="tooltip"
              initialValue={values?.title || ''}
            />
            <Checkbox
              $status={checkLabel === 'wrong' || checkLabel === 'isLabel' ? false : !!label}
              onClick={() => {
                if (label && !checking) {
                  onCheck();
                }
            }}>
              {checking ? (
                <ProgressSpinner style={{ width: 18, height: 18 }} strokeWidth="8" />
              ) : (
                <FormattedMessage
                  id="NewRelease.ReleaseInfo.Check"
                  defaultMessage="Check"
                />
              )}
            </Checkbox>
          </Box>
          <LabelBox >
            <div style={{ backgroundColor: checkLabel === 'isLabel' ? '#EFFFF1' : checkLabel === 'wrong' ? '#FFBBBB' : '#E9E9E9' }}>
              {checking ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <ProgressSpinner style={{ width: 18, height: 18 }} strokeWidth="8" />
                  <FormattedMessage
                    id="NewRelease.ReleaseInfo.CheckingLabelAvailability"
                    defaultMessage="Checking label availability"
                  />
                </div>
              ) : checkLabel === 'isLabel' ? (
                <FormattedMessage
                  id="NewRelease.ReleaseInfo.LabelIsAvailable"
                  defaultMessage="Label is available"
                />
              ) : checkLabel === 'wrong' ? (
                <FormattedMessage
                  id="NewRelease.ReleaseInfo.LabelIsNotAvailable"
                  defaultMessage="The label is not available"
                />
              ) : (
                <FormattedMessage
                  id="NewRelease.ReleaseInfo.CheckingLabelAvailability"
                  defaultMessage="Checking label availability"
                />
              )}
            </div>
          </LabelBox>
        </Section> : labels?.length !== 0 ?
          <SelectBox>
            <FormSelect
              id="label"
              name="label"
              label={IntlStore.intl.formatMessage({
                id: "NewRelease.ReleaseInfo.AvailableLabel",
                defaultMessage: "Label"
              })}
              placeholder={IntlStore.intl.formatMessage({
                id: "NewRelease.ReleaseInfo.ReleaseAvailableLabel.Placeholder",
                defaultMessage: "Enter label name"
              })}
              items={
                labels?.map((val: LabelItem) => ({
                  value: val.id,
                  label: val.name
                })) ?? []
              }

              initialValue={values?.label?.id}
              addLabelHandler={() => {

              }}
              onChange={(option) => {
              }}
              onHide={onHide}
              setSelectedlabel={setSelectedlabel}
              values={values}
              setCreate={setCreate}
            />

            <CreateBoxButton onClick={() => setCreate('Create')}>
              <FormattedMessage
                id="NewRelease.ReleaseInfo.CreateNewLabel"
                defaultMessage="Add label"
              />
            </CreateBoxButton>
          </SelectBox>
          :
          <CreateBox>
            <span>
              <FormattedMessage
                id="NewRelease.ReleaseInfo.CreateBoxTitle"
                defaultMessage="No labels yet! Let's make your first one!"
              />
            </span>
            <ButtonBox>
              <span onClick={() => { onHide(), setCreate(''), values.label = null }}>
                <FormattedMessage
                  id="NewRelease.ReleaseInfo.Cancel"
                  defaultMessage="Cancel"
                />
              </span>
              <div onClick={() => setCreate('Create')}>
                <FormattedMessage
                  id="NewRelease.ReleaseInfo.CreateNewLabel"
                  defaultMessage="Create a new label"
                />
              </div>
            </ButtonBox>
          </CreateBox>
        }
      </FormContainer>
    </Modal>
  );
};

const FormContainer = styled.div`
  width: 490px;
  padding: 16px 0 0;

  /* Mobile: fit dialog into viewport and allow scrolling within content */
  @media (max-width: 768px) {
    width: min(100%);
    max-height: calc(100dvh - 180px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
`
const Section = styled.div`
  width:100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`
const Label = styled.div`
  font-family: SF Pro Display;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
`
const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 -24px;

  /* Mobile: avoid negative margins causing horizontal overflow */
  @media (max-width: 768px) {
    margin: 0;
  }
`
const Box = styled.div`
  width:100%;
  display:flex; 
  align-items: flex-end;
  justify-content: center;
  gap:5px;

  /* Mobile: stack input + check button to prevent horizontal overflow */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`
const Checkbox = styled.div<{ $status: boolean }>`
  width: 111px;
  height: 46px;
  border-radius: 8px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  border: 1px solid ${({ $status }) => ($status ? '#28a745' : '#E9E9E9')};
  background-color: ${({ $status }) => ($status ? '#6777FF' : '#FFFFFF')};
  color: ${({ $status }) => ($status ? '#FFFFFF' : '#A4A4A4')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor:pointer;

  @media (max-width: 768px) {
    width: 100%;
    height: 44px;
  }
`
const LabelBox = styled.div<{ $status?: 'isLabel' | 'wrong' | 'default' }>`
  width: 100%;
  font-family: SF Pro Display;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  color:#000000;

  div{
    width:100%;
    height:100%;
    padding:18px 0 18px 16px;
    border-radius: 15px;
  }
`
const CreateBox = styled.div`
  padding-top:19px;
  display:flex; 
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap:19px;
  span{
    font-family: SF Pro Display;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #000000;
  }
`
const ButtonBox = styled.div`
  display:flex; 
  gap:10px;
  align-items: center;
  justify-content: center;
  cursor:pointer;
  span{
    font-family: SF Pro Display;
    font-weight: 600;
    font-style: Semibold;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color:#000000;
    cursor:pointer;
  }

  div{
    width: 122px;
    height: 35px;
    border-radius: 8px;
    angle: 0 deg;
    opacity: 1;
    display:flex; 
    align-items: center;
    justify-content: center;
    background-color:#6777FF;
    font-family: SF Pro Display;
    font-weight: 600;
    font-style: Semibold;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color:#FFFFFF;
    cursor:pointer;
  }
`
const SelectBox = styled.div`
  width: 100%;
  max-height:142px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 13px;
  overflow:hidden;
  z-index:1;

  @media (max-width: 768px) {
    max-height: none;
    overflow: visible;
  }
`
const CreateBoxButton = styled.div`
  width: 122px;
  height: 35px;
  border-radius: 8px;
  background:#6777FF;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  display:flex;
  align-items: center;
  justify-content: center;
  color:#FFFFFF;
  cursor:pointer;
`
